// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_availability_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `In Stock — Ready to Ship`
};

const el_availability_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `Σε Απόθεμα — Έτοιμο για Αποστολή`
};

const ru_availability_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `В наличии — Готово к отправке`
};

const he_availability_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `במלאי — מוכן למשלוח`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const availability_in_store = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.availability_in_store(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("availability_in_store", locale)
	if (locale === "en") return en_availability_in_store(inputs)
	if (locale === "el") return el_availability_in_store(inputs)
	if (locale === "ru") return ru_availability_in_store(inputs)
	if (locale === "he") return he_availability_in_store(inputs)
	return "availability_in_store"
};